import { isNil } from '@lucidlink/tscore';
import { InvalidArgumentError } from '#common/types';
import { ObjectStoreCredentialsKind, } from '#object-store/types';
export function createAzureCredentialsConfig(config) {
    const azureConfig = createCommonAzureConfig(config);
    if (isNil(config.credentials)) {
        throw new InvalidArgumentError('Missing object store credentials');
    }
    if (config.credentials.kind !== ObjectStoreCredentialsKind.IAM) {
        throw new InvalidArgumentError('Azure object store requires IAM credentials');
    }
    return { ...azureConfig, credentials: config.credentials };
}
export function createAzureSasConfig(config, sasContext) {
    const azureConfig = createCommonAzureConfig(config);
    if (isNil(sasContext)) {
        throw new InvalidArgumentError('Missing object sas context');
    }
    return { ...azureConfig, sasContext };
}
function createCommonAzureConfig(config) {
    const res = {
        httpScheme: config.httpScheme,
    };
    if (config.endpointOverride) {
        res.endpointSuffix = config.endpointOverride;
    }
    return res;
}
